<div class="dialog-wrapper">

    <div class="dialog-header">
        <div class="dialog-header-left">
            <span class="dialog-header-icon">⚡</span>
            <h4 class="dialog-title">Process All</h4>
        </div>
        <button mat-icon-button class="close-btn" (click)="cancel()">
            <mat-icon>close</mat-icon>
        </button>
    </div>

    <div mat-dialog-content class="dialog-content">
        <form [formGroup]="form">

            <div class="section-label">Payroll &amp; Period</div>
            <div class="field-row">

                <mat-form-field appearance="outline" class="half-field">
                    <mat-label>Payroll Type</mat-label>
                    <mat-select formControlName="payrollID"
                        (selectionChange)="onPayrollSelected($event.value)"
                        (openedChange)="onDropdownOpenChange($event, 'payroll')">
                        <mat-select-trigger>{{ getPayrollTypeName(form.get('payrollID')?.value) || 'Select Payroll Type' }}</mat-select-trigger>
                        <mat-option class="search-option">
                            <input #payrollSearch [(ngModel)]="payrollSearchText" [ngModelOptions]="{standalone: true}"
                                (ngModelChange)="filterPayrolls()" (click)="$event.stopPropagation()"
                                placeholder="Search..." class="search-input">
                        </mat-option>
                        <mat-option [value]="null">-- None --</mat-option>
                        <mat-option *ngFor="let t of filteredPayrollTypes" [value]="t.hrpayrollID">{{ t.payrollType }}</mat-option>
                        <mat-option *ngIf="filteredPayrollTypes.length === 0 && payrollSearchText" disabled><em>No results</em></mat-option>
                    </mat-select>
                    <mat-error>Payroll type is required.</mat-error>
                </mat-form-field>

                <mat-form-field appearance="outline" class="half-field">
                    <mat-label>Period</mat-label>
                    <mat-select formControlName="periodID"
                        (openedChange)="onDropdownOpenChange($event, 'period')">
                        <mat-select-trigger>{{ getPeriodName(form.get('periodID')?.value) || 'Select Period' }}</mat-select-trigger>
                        <mat-option class="search-option">
                            <input #periodSearch [(ngModel)]="periodSearchText" [ngModelOptions]="{standalone: true}"
                                (ngModelChange)="filterPeriods()" (click)="$event.stopPropagation()"
                                placeholder="Search..." class="search-input">
                        </mat-option>
                        <mat-option [value]="null">-- None --</mat-option>
                        <mat-option *ngFor="let p of filteredPeriods" [value]="p.hrperiodID">{{ p.payrollName }}</mat-option>
                        <mat-option *ngIf="filteredPeriods.length === 0 && !form.get('payrollID')?.value" disabled><em>Select a payroll type first</em></mat-option>
                    </mat-select>
                    <mat-error>Period is required.</mat-error>
                </mat-form-field>

            </div>

            <div class="section-label mt-section">
                <span class="step-badge">Step 1</span>
                Process Import Timesheet
            </div>
            <div class="checkbox-row">
                <mat-checkbox formControlName="excludeSeconds" color="primary">Exclude Seconds</mat-checkbox>
            </div>

            <div class="section-label mt-section">
                <span class="step-badge">Step 2</span>
                Batch Process Timesheet
            </div>
            <div class="field-row">

                <mat-form-field appearance="outline" class="half-field">
                    <mat-label>Employee (optional)</mat-label>
                    <mat-select formControlName="bpartnerID" (openedChange)="onDropdownOpenChange($event, 'employee')">
                        <mat-select-trigger>{{ getEmployeeName(form.get('bpartnerID')?.value) || 'All Employees' }}</mat-select-trigger>
                        <mat-option class="search-option">
                            <input #employeeSearch [(ngModel)]="employeeSearchText" [ngModelOptions]="{standalone: true}"
                                (ngModelChange)="filterEmployees()" (click)="$event.stopPropagation()"
                                placeholder="Search..." class="search-input">
                        </mat-option>
                        <mat-option [value]="null">All Employees</mat-option>
                        <mat-option *ngFor="let e of filteredEmployees" [value]="e.C_BPartner_ID">{{ e.employeeName }}</mat-option>
                    </mat-select>
                </mat-form-field>

                <mat-form-field appearance="outline" class="half-field">
                    <mat-label>Document Status</mat-label>
                    <mat-select formControlName="docStatus">
                        <mat-option value="">Any</mat-option>
                        <mat-option value="DR">Draft</mat-option>
                        <mat-option value="IP">In Progress</mat-option>
                        <mat-option value="CO">Completed</mat-option>
                        <mat-option value="VO">Voided</mat-option>
                    </mat-select>
                </mat-form-field>

            </div>

            <div class="checkbox-row">
                <mat-checkbox formControlName="generateInvoice" color="primary">Generate Payroll Invoice</mat-checkbox>
            </div>

            <ng-container *ngIf="generateInvoice">
                <div class="field-row">
                    <mat-form-field appearance="outline" class="half-field">
                        <mat-label>Date Invoiced</mat-label>
                        <input matInput [matDatepicker]="invoicePicker" placeholder="MM/DD/YYYY" formControlName="dateInvoiced" />
                        <mat-datepicker-toggle matSuffix [for]="invoicePicker"></mat-datepicker-toggle>
                        <mat-datepicker #invoicePicker></mat-datepicker>
                        <mat-error>Date is required.</mat-error>
                    </mat-form-field>
                    <div class="checkbox-row align-self-center half-field">
                        <mat-checkbox formControlName="allocateByBranch" color="primary">Allocate charges by branch</mat-checkbox>
                    </div>
                </div>

                <hr class="section-divider">

                <div class="field-row">
                    <mat-form-field appearance="outline" class="third-field">
                        <mat-label>SSS Computation Period</mat-label>
                        <mat-select formControlName="sss" (openedChange)="onDropdownOpenChange($event, 'sss')">
                            <mat-select-trigger>{{ getSSSName(form.get('sss')?.value) || 'Select' }}</mat-select-trigger>
                            <mat-option class="search-option">
                                <input #sssSearch [(ngModel)]="sssSearchText" [ngModelOptions]="{standalone: true}"
                                    (ngModelChange)="filterSSS()" (click)="$event.stopPropagation()" placeholder="Search..." class="search-input">
                            </mat-option>
                            <mat-option *ngFor="let item of filteredSSS" [value]="item.value">{{ item.name }}</mat-option>
                        </mat-select>
                    </mat-form-field>

                    <mat-form-field appearance="outline" class="third-field">
                        <mat-label>Pag-IBIG Computation Period</mat-label>
                        <mat-select formControlName="pagibig" (openedChange)="onDropdownOpenChange($event, 'pagibig')">
                            <mat-select-trigger>{{ getPagIbigName(form.get('pagibig')?.value) || 'Select' }}</mat-select-trigger>
                            <mat-option class="search-option">
                                <input #pagibigSearch [(ngModel)]="pagibigSearchText" [ngModelOptions]="{standalone: true}"
                                    (ngModelChange)="filterPagIbig()" (click)="$event.stopPropagation()" placeholder="Search..." class="search-input">
                            </mat-option>
                            <mat-option *ngFor="let item of filteredPagIbig" [value]="item.value">{{ item.name }}</mat-option>
                        </mat-select>
                    </mat-form-field>

                    <mat-form-field appearance="outline" class="third-field">
                        <mat-label>PhilHealth Computation Period</mat-label>
                        <mat-select formControlName="philhealth" (openedChange)="onDropdownOpenChange($event, 'philhealth')">
                            <mat-select-trigger>{{ getPhilhealthName(form.get('philhealth')?.value) || 'Select' }}</mat-select-trigger>
                            <mat-option class="search-option">
                                <input #philhealthSearch [(ngModel)]="philhealthSearchText" [ngModelOptions]="{standalone: true}"
                                    (ngModelChange)="filterPhilhealth()" (click)="$event.stopPropagation()" placeholder="Search..." class="search-input">
                            </mat-option>
                            <mat-option *ngFor="let item of filteredPhilhealth" [value]="item.value">{{ item.name }}</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>

                <div class="checkbox-row">
                    <mat-checkbox formControlName="adjustBaseSss" color="primary">Adjust base on last SSS contribution</mat-checkbox>
                </div>
            </ng-container>

        </form>
    </div>

    <div mat-dialog-actions class="dialog-footer">
        <button mat-stroked-button (click)="cancel()">Cancel</button>
        <button mat-raised-button class="btn-success" [disabled]="form.invalid" (click)="startProcessAll()">
            <mat-icon>play_circle</mat-icon>
            Process All
        </button>
    </div>

</div>
